import React, { useState } from 'react';
import { styled } from '@mui/system';

import Dialog from '@mui/material/Dialog';

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { ToastContainer, toast } from 'react-toastify';
import Spinner from '../../UIComponents/Spinner/Spinner';
import 'react-toastify/dist/ReactToastify.css';
import SimpleImageSlider from 'react-simple-image-slider';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 


const theme = createTheme();




const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));
const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#eaf7fdcc",
}));


const ImagePopUp = (props) => {
  const [open, setOpen] = React.useState(props.editing);
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState('sm');

  const [projectStat, setProjectStat] = useState('');
  const [dataImage] = useState(props.dataImage);

  const handleClose = () => {
    setOpen(false);
    props.setEditing(false);
    props.setIsOPen(false);
  };

  return (
    <ThemeProvider theme={theme}>
    <div>
    <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          style={{}}
        >
          <CustomDialogTitle onClose={handleClose}>
          <p style={{ fontSize: '1.5em' }}>Images</p>
          </CustomDialogTitle>
          <CustomDialogContent dividers>
          {!props.isOpen ? (
            <Spinner />
          ) : (
            <form
              className='form-horizontal '
              style={{ backgroundColor: '#eaf7fdcc' }}
              onSubmit={(event) => {
                event.preventDefault();
                if (projectStat === '') {
                  toast.error('Please select the status', {
                    position: 'top-right',
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                } else {
                  props.setEditing(false);
                  setOpen(false);
                }
              }}
            >
              <div className='form-group'>
                <ToastContainer
                  position='top-right'
                  autoClose={2000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  className=''
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
                <div className='col-md-12'>
                  {/*   <SimpleImageSlider
                    width={500}
                    height={500}
                    images={props.imagePath}
                    showNavs={true}
                    showBullets={true}
                  /> */}
                  {props.imagePath.length > 0
                    ? props.imagePath.map((data) => (
                        <div>
                          <img
                            src={data.url}
                            alt={'image'}
                            style={{
                              width: 500,
                              height: 500,
                            }}
                          />

                          <div
                            className='todo-icon'
                            style={{ fontSize: '1.73em' }}
                          >
                            <span
                              className='mx-8 text-success text-right'
                              style={{
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                props.downloadImage(data.path);
                              }}
                            >
                              <i className='fas fa-download'></i>
                            </span>
                          </div>
                        </div>
                      ))
                    : ''}
                </div>
              </div>

              <div className='form-group'></div>
            </form>
          )}
        </CustomDialogContent>
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default ImagePopUp;
